import { Button, Divider, Row } from 'antd';
import { Form } from '@/components';
import { useTranslation } from 'react-i18next';
import { useReportingProjectsLookupSource } from '@/views';
import { useField } from 'formik';
import { useBool } from '@/utils';
import { useEffect, useState } from 'react';

interface Props {
  name: string;
  communityId?: string | string[];
  label?: React.ReactNode;
  placeholder?: string;
  showCommunityName?: boolean;
}

export function ReportingProjectSelect(props: Props) {
  const { communityId, name, label, placeholder, showCommunityName } = props;
  const projectsDataSource = useReportingProjectsLookupSource(
    showCommunityName ?? true,
    communityId,
  );
  const [options, setOptions] = useState<string[]>();
  const [{ value }, , { setValue }] = useField(name);
  const { t } = useTranslation();
  const [allSelected, setAllSelected, toggleAllSelected] = useBool(false);
  const handleAllSelect = () => {
    if (allSelected) {
      setValue(undefined);
    } else {
      setValue(options);
    }
    toggleAllSelected();
  };

  useEffect(() => {
    setAllSelected(value?.length === options?.length);
  }, [options?.length, setAllSelected, value]);

  return (
    <Form.AsyncSelect
      key={`${communityId}`}
      name={name}
      dataSource={projectsDataSource}
      required
      mode="multiple"
      onSearchLoad={(options) => setOptions(options.map((x) => x.value))}
      maxTagCount={2}
      maxTagTextLength={10}
      label={label}
      placeholder={placeholder}
      dropdownRender={(menu) => (
        <>
          {menu}
          <>
            <Divider style={{ margin: '2px' }} />
            <Row justify="center" className="p-2">
              <Button type="link" onClick={handleAllSelect}>
                {t(
                  `reports.homeStatus.${
                    allSelected ? 'unselectAll' : 'selectAll'
                  }`,
                )}
              </Button>
            </Row>
          </>
        </>
      )}
    />
  );
}
